<template>
    <div class="query">
<!--        <div class="title">-->
<!--            <p class="return" @click="back">-->
<!--                <img src="~@public/img/user/login/jian.png"/>-->
<!--            </p>-->
<!--            全国异地证办证进度查询-->
<!--        </div>-->
        <van-cell-group>
            <van-field v-model="handlingId" clearable label="身份证号:" readonly placeholder="请输入身份证号"/>
            <!--<verification-code-input @setVerificationCode="getVerificationCode"
                                     ref="childFunction"></verification-code-input>-->
            <Vue2Verify ref="verify" v-if="show" @closeClick="show = false" @success='success'
                        :imgSize="{width:'310px',height:'155px'}"></Vue2Verify>
        </van-cell-group>
        <div class="btn-submit-div">
            <van-button type="info" size="large" @click="submit">查询</van-button>
        </div>
        <div class="boxList" v-for="(item, index) in dataList" :key="index" v-if="listShow">
            <div class="boxList-item">
                <span>受理编号:</span>
                <span>{{item.slh}}</span>
            </div>
            <div class="boxList-item">
                <span>姓名:</span>
                <span>{{item.sfzname}}</span>
            </div>
            <div class="boxList-item">
                <span>证件号:</span>
                <span>{{item.sfzno}}</span>
            </div>
            <div class="boxList-item">
                <span>受理时间:</span>
                <span>{{item.sldate}}</span>
            </div>
            <div class="boxList-item">
                <span>签发机关:</span>
                <span>{{item.issuingauth}}</span>
            </div>
            <div class="boxList-item">
                <span>办理状态:</span>
                <span>{{item.sfzflag}}</span>
            </div>
        </div>

    </div>
</template>

<script>

    import {CellGroup, Field, Toast, Button} from 'vant'
    import VerificationCodeInput from "@/components/verification-code-input/VerificationCodeInput";
    import {queryApiMap} from "@/api/query";
    import { idCardRegex } from '@/utils/regex'
    import Vue2Verify from "@/views/signUp/verify/verify"
    import {memberApi} from "../../api/member";

    export default {
        name: "DifferentQuery",
        components: {
            Vue2Verify,
            VerificationCodeInput,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Toast.name]: Toast,
            [Button.name]: Button
        },
        data() {
            return {
                show: false,
                handlingId: '', // 身份证号
                receiveVerificationCode: {}, // 接收验证码子组件传来verificationInfo对象
                value: '',
                listShow:true,
                dataList:[]
            }
        },

        mounted() {
            this.initUser()
        },

        methods: {
            onConfirm(value) {
                this.value = value;
            },
            /**
             * 接收验证码输入框组件传来的verificationInfo对象
             * @param value 验证码输入框verificationInfo对象
             */
            getVerificationCode(value) {
                this.receiveVerificationCode = value
            },

            /**
             * 初始化用户
             */
            // 用户信息非必需
            async initUser() {
                let _self = this;
                let userInfo = {};
                try {
                    const res = await _self.$httpUtils.getGatewayUtils(memberApi.getUserInfo)
                    console.log("用户信息")
                    console.log(res)
                    if (res.data.succ) {
                        userInfo = res.data.data
                        this.handlingId=userInfo.idNum
                    } else {
                        Toast.fail('网络异常，请检查网络')
                    }
                } catch (e) {
                    Toast.fail('服务器运行失败，请稍后再试。')
                    console.log(e)
                }
                return userInfo;
            },

          submit() {
            if (!this.handlingId) {
              Toast('请输入身份证号')
            } else if(!idCardRegex(this.handlingId)) {
              Toast('请输入正确的身份证号')
            } else {
              this.show=true
            }
          },

          async success(val) {
            Toast.loading({
              duration: 0,       // 持续展示 toast
              forbidClick: true, // 禁用背景点击
              loadingType: 'spinner',
              message: '查询中...'
            })
            try {
              // 证件类型 10：异地 11：港澳 12：台湾
              const data = {
                idNum: this.handlingId,
                type: 10,
                genGuid: val.captchaVerification,
                validCode: val.captchaVerification
              }
              const res = await this.$httpUtils.postCommonUtils(`${queryApiMap.makecard}`, data)
              this.show = false
              Toast.clear()
              if (res.data.succ) {
                let data = res.data.data;
                if(data.length > 0) {
                  this.listShow = true
                  data.forEach(obj=>{
                    obj.sldate = obj.sldate.substring(0,4)+'-'+obj.sldate.substring(4,6)+'-'+obj.sldate.substring(6)
                  })
                  this.dataList = Object.assign([], data)
                } else {
                  Toast.fail('暂无数据')
                }
              } else {
                Toast.fail('查询失败')
              }
            } catch (error) {
              Toast.fail('服务器运行失败，请稍后再试。')
              console.log(error)
            }
          },

            /**
             * 点击查询
             */
            async query() {
                if (!this.handlingId) {
                    Toast('请输入身份证号')
                } else if(!idCardRegex(this.handlingId)) {
                    Toast('请输入正确的身份证号')
                } else if (!this.receiveVerificationCode.verificationIsNoneStatus) {
                    Toast('请输入验证码')
                } else if (!this.receiveVerificationCode.verificationSuccessStatus) {
                    Toast('请输入正确的验证码')
                } else {
                    Toast.loading({
                        duration: 0,       // 持续展示 toast
                        forbidClick: true, // 禁用背景点击
                        loadingType: 'spinner',
                        message: '查询中...'
                    })
                    try {
                        // 证件类型 10：异地 11：港澳 12：台湾
                        const data = {
                            idNum: this.handlingId,
                            type: 10,
                            genGuid: this.receiveVerificationCode.verificationCodeGuid,
                            validCode: this.receiveVerificationCode.verificationCode
                        }
                        const res = await this.$httpUtils.postCommonUtils(`${queryApiMap.makecard}`, data)
                        Toast.clear()
                        if (res.data.succ) {
                            let data = res.data.data;
                            if(data.length > 0) {
                                this.listShow = true
                                data.forEach(obj=>{
                                    obj.sldate = obj.sldate.substring(0,4)+'-'+obj.sldate.substring(4,6)+'-'+obj.sldate.substring(6)
                                })
                                this.dataList = Object.assign([], data)
                            } else {
                                Toast.fail('暂无数据')
                                this.$refs.childFunction.interactionVerificationCode()
                            }
                        } else {
                            Toast.fail('查询失败')
                            this.$refs.childFunction.interactionVerificationCode()
                        }
                    } catch (error) {
                        Toast.fail('服务器运行失败，请稍后再试。')
                        console.log(error)
                    }
                }
            },
            back() {
                this.$router.go(-1);
            }
        }
    }
</script>

<style scoped>

</style>
<style>
    @import "~@assets/css/public/Common.css";
</style>
